import { setData } from "rivals/shared/utils/qa";
import styles from "./index.module.scss";
import strings from "./strings";
import { OwnProps } from "./types";

const { description, endResults, noResults } = strings;

const EndResultsCard = ({ data = "", emptyResults }: OwnProps): JSX.Element => {
  return (
    <div className={styles.wrapper} {...setData(data, "end-results-card")}>
      <div className={styles.title}>
        {emptyResults ? noResults : endResults}
      </div>
      <div className={styles.description}>{description}</div>
    </div>
  );
};

export default EndResultsCard;
